export default "__VITE_ASSET__cf43ea00__"